// @TODO how to NOT use import
import Home from './Home';
export default Home;


export { default as Home } from './Home';



// WEBPACK FOOTER //
// ./src/containers/pages/Home/index.js